export { CustomerPanel } from "./components/CustomerPanel";
